'use client';
var classes = {"root":"m_1b7284a3"};

export { classes as default };
//# sourceMappingURL=Paper.module.css.mjs.map
